<template>
  <router-view />
</template>

<script>
export default {
  name: 'FlightsIndex'
}
</script>
